/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface JpvParcelDto { 
    accountingPrice?: number;
    acquisitionTax?: number;
    acquisitionTaxAdd?: number;
    buyPrice?: number;
    cena?: number;
    cenaPopis?: string;
    cislKod?: number;
    cislNazev?: string;
    coefLocation?: number;
    dnepduos1Acreage?: number;
    dnepduos1Year?: number;
    dnepduos2Acreage?: number;
    dnepduos2Year?: number;
    dnepduos3Acreage?: number;
    dnepduos3Year?: number;
    drupozKod?: number;
    drupozKodMan?: number;
    drupozNazev?: string;
    endDate?: string;
    id?: number;
    katuzeKod?: number;
    katuzeKodPuv?: number;
    katuzeNazev?: string;
    katuzeNazevPuv?: string;
    koeficient: number;
    krajKod?: number;
    krajNazev?: string;
    lv?: number;
    maplis?: string;
    nazevZe?: string;
    nebonitovanaVymera?: number;
    obecKod?: number;
    obecNazev?: string;
    okresKod?: number;
    okresNazev?: string;
    osvobozenaVymera?: number;
    parId?: number;
    parType?: string;
    parcelRentAveragePrice?: number;
    parcelRentFromAcreage?: number;
    parcelRentParcelPrice?: number;
    parcis?: string;
    parcisDil?: number;
    parcisKmen?: number;
    parcisPod?: number;
    priceAddAveragePrice?: number;
    priceAddAveragePricePercent?: number;
    priceAddParcelPrice?: number;
    priceAddParcelPricePercent?: number;
    pronajataVymera: number;
    prumernaCena?: number;
    realEstateBrokerage?: number;
    startDate?: string;
    tax?: number;
    taxAdd?: number;
    taxComputed?: number;
    taxFromRentedAcreage?: number;
    taxPayerId?: number;
    taxTenant?: boolean;
    type?: number;
    typeValid?: number;
    useTaxFromRentedAcreage?: boolean;
    vymera?: number;
    vymeraDoplneni?: number;
    zastavenaVymera?: number;
    zeKod?: number;
    zpevnenaPlochaX?: number;
    zpevnenaPlochaY?: number;
    zpurvyKod?: number;
    zpurvyNazev?: string;
    zpvypoKod?: number;
    zpvypoNazev?: string;
}

